import createCrud from '../crud';

export default createCrud({
    resource: 'documents',
    parent: 'opportunity'
  });